import script from "./AppSystemBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSystemBanner.vue?vue&type=script&setup=true&lang=js"

import "./AppSystemBanner.vue?vue&type=style&index=0&id=5ab06e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab06e1a"]])

export default __exports__